export default __webpack_public_path__ + "static/media/ISEO CLASS 5 SYLLABUS.cc47973e.pdf";